module.exports = __webpack_public_path__ + "img/testing-assumptions.408532b0.png";